import type { Assortment_AdminFragment } from '../../graphql';
import type { ScenarioLocation } from '../../lib/planningData';
import type { MultiKey } from '../core/MultiKey';
import type {
  PortCostData,
  MarcuraPortCosts,
  MarcuraPortCostParams,
} from './context';

export class PortCostMap implements MarcuraPortCosts {
  map: MultiKey<PortCostData, MarcuraPortCostParams>;
  locationsById: Map<number, ScenarioLocation>;
  assortmentsById: Map<number, Assortment_AdminFragment>;

  constructor(
    map: MultiKey<PortCostData, MarcuraPortCostParams>,
    locationsById: Map<number, ScenarioLocation>,
    assortmentsById: Map<number, Assortment_AdminFragment>,
  ) {
    this.map = map;
    this.locationsById = locationsById;
    this.assortmentsById = assortmentsById;
  }

  get(locationId: number, assortmentId: number): PortCostData | undefined {
    const portExternalId = this.locationsById.get(locationId)?.externalId;
    const assortmentGroupExternalId =
      this.assortmentsById.get(assortmentId)?.assortmentGroupByAssortmentGroup
        ?.externalId;
    if (!portExternalId || !assortmentGroupExternalId) {
      return undefined;
    }
    return this.map.get(portExternalId, assortmentGroupExternalId);
  }

  set(data: PortCostData): void {
    this.map.set(data, data.marcura_port_id, data.marcura_group_id);
  }
}
